import { render, staticRenderFns } from "./ClimberCloud.vue?vue&type=template&id=0f2182a9&scoped=true"
import script from "./ClimberCloud.vue?vue&type=script&lang=js"
export * from "./ClimberCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2182a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
